<template>
  <el-dialog
    title="查看视频"
    :visible.sync="visible"
    width="1400px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    class="video-dialog"
    custom-class="video-dialog-wrapper"
  >
    <div class="search-form">
      <el-input
        v-model.trim="searchForm.keyword"
        placeholder="请输入名称"
        style="width: 300px; margin-right: 10px"
        size="small"
        clearable
      />
      <el-button
        type="primary"
        @click="handleSearch"
        size="small"
        >查询</el-button
      >
    </div>

    <el-table
      :data="videoList"
      style="width: 100%; margin-top: 20px"
      max-height="800"
      stripe
    >
      <el-table-column
        label="视频"
        width="120"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.thumbnail"
            style="width: 50px; height: 50px; object-fit: cover"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="标题"
        width="300"
      >
        <template slot-scope="scope">
          <div
            v-if="scope.row.editing"
            class="edit-title"
          >
            <el-input
              v-model="scope.row.editTitle"
              size="small"
              style="width: 150px; margin-right: 8px"
            />
            <el-button
              size="mini"
              type="primary"
              :disabled="!scope.row.editTitle.trim()"
              :loading="scope.row.updating"
              @click="confirmEdit(scope.row)"
              >确定</el-button
            >
            <el-button
              size="mini"
              @click="cancelEdit(scope.row)"
              >取消</el-button
            >
          </div>
          <div
            v-else
            class="title-display hover-cell"
          >
            <span :title="scope.row.videoTitle">{{ scope.row.videoTitle }}</span>
            <i
              class="el-icon-edit edit-icon"
              @click="startEdit(scope.row)"
            ></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="公开范围"
        width="180"
      >
        <template slot-scope="scope">
          <div class="privacy-display hover-cell">
            <span>
              <!-- 限制有值：1 length为249 -->
              <span v-if="scope.row.blockedLocation?.length">
                <span
                  v-if="scope.row.blockedLocation.length < 249"
                  style="color: #e6a23c"
                >
                  <i class="el-icon-warning"></i>
                  部分国家/地区禁播</span
                >
                <span
                  v-else
                  style="color: #f56c6c"
                >
                  <i class="el-icon-remove-outline"></i>
                  禁播</span
                >
              </span>
              <span v-else>
                {{ privacyStatusMap[scope.row.status] }}
              </span>
            </span>
            <i
              class="el-icon-edit edit-icon"
              @click="openPrivacyDialog(scope.row)"
            ></i>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="限制"
        width="100"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="
              scope.row.blockedLocation &&
              Array.isArray(scope.row.blockedLocation) &&
              scope.row.blockedLocation.length > 0
            "
            content="当前视频在部分地区禁用"
            placement="top"
          >
            <span>版权</span>
          </el-tooltip>
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column
        label="日期"
        width="240"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createTime || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="viewCount"
        label="观看次数"
        width="100"
      />
      <el-table-column
        label="评论数"
        width="80"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.commentCount ?? '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="likeCountRatio"
        label="赞和不喜欢的比例"
        width="200"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.likeCountRatio || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="copyLink(scope.row)"
            style="color: #409eff"
            >复制链接</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="confirmDelete(scope.row)"
            style="color: #409eff"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="load-more">
      <el-button
        v-if="nextPageToken"
        @click="loadMore"
        >加载更多</el-button
      >
      <span v-else>
        <span v-if="videoList.length > 0">没有更多了</span>
      </span>
    </div>

    <!-- 公开范围编辑弹窗 -->
    <el-dialog
      title="保存或发布"
      :visible.sync="privacyDialogVisible"
      width="400px"
      append-to-body
      :before-close="closePrivacyDialog"
    >
      <el-radio-group v-model="selectedPrivacy">
        <el-radio label="private">私享</el-radio>
        <el-radio label="unlisted">不公开列出</el-radio>
        <el-radio label="public">公开</el-radio>
      </el-radio-group>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="closePrivacyDialog">取消</el-button>
        <el-button
          type="primary"
          @click="confirmPrivacyChange"
          :loading="privacyUpdating"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { searchVideoByChannel, updateYoutubeVideo, deleteVideo } from '@/api/google/youtube';

export default {
  name: 'ViewChannelVideos',
  props: {
    viewVideosShow: {
      type: Boolean,
      default: false,
    },
    channelId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      searchForm: {
        keyword: '',
      },
      videoList: [],
      nextPageToken: null,
      privacyDialogVisible: false,
      selectedPrivacy: '',
      originalPrivacy: '',
      currentEditingRow: null,
      privacyUpdating: false,
      privacyStatusMap: {
        unlisted: '不公开列出',
        public: '公开',
        private: '私享',
      },
      deleteDialogVisible: false,
      currentDeleteRow: null,
      deleting: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.viewVideosShow;
      },
      set(val) {
        this.$emit('update:viewVideosShow', val);
      },
    },
  },
  watch: {
    async viewVideosShow(val) {
      if (val) {
        this.resetData();
        await this.$nextTick();
        this.loadVideos();
      }
    },
  },
  methods: {
    resetData() {
      this.searchForm.keyword = '';
      this.videoList = [];
      this.nextPageToken = null;
    },

    async loadVideos(isLoadMore = false) {
      try {
        const params = {
          youtubeChannelId: this.channelId,
          keyword: this.searchForm.keyword,
          nextPageToken: isLoadMore ? this.nextPageToken : null,
        };
        this.$showLoading();
        const res = await searchVideoByChannel(params);

        if (res.code === 0) {
          if (isLoadMore) {
            this.videoList = [...this.videoList, ...res.data.videoList];
          } else {
            this.videoList = res.data.videoList;
          }
          this.nextPageToken = res.data.nextPageToken || null;
        }
      } catch (error) {
        console.error('加载视频失败:', error);
      } finally {
        this.$hideLoading();
      }
    },

    handleSearch() {
      this.nextPageToken = null;
      this.loadVideos();
    },

    loadMore() {
      this.loadVideos(true);
    },

    handleClose() {
      this.visible = false;
    },

    startEdit(row) {
      this.$set(row, 'editing', true);
      this.$set(row, 'editTitle', row.videoTitle);
    },

    cancelEdit(row) {
      this.$set(row, 'editing', false);
      this.$set(row, 'editTitle', '');
      this.$set(row, 'updating', false);
    },

    async confirmEdit(row) {
      const newTitle = row.editTitle.trim();
      if (newTitle === row.videoTitle) {
        this.cancelEdit(row);
        return;
      }

      this.$set(row, 'updating', true);
      try {
        const res = await updateYoutubeVideo({
          youtubeCredentialId: row.youtubeCredentialId,
          videoId: row.videoId,
          title: newTitle,
          categoryId: row.categoryId,
        });
        if (res.code === 0) {
          row.videoTitle = newTitle;
          this.cancelEdit(row);
          this.$message.success('更新成功');
        } else {
          this.$set(row, 'updating', false);
        }
      } catch (error) {
        console.log('更新视频标题失败:', error);
        this.$set(row, 'updating', false);
      }
    },

    getPrivacyText(status) {
      return this.privacyStatusMap[status] || status || '-';
    },

    openPrivacyDialog(row) {
      this.currentEditingRow = row;
      this.selectedPrivacy = row.status || '';
      this.originalPrivacy = row.status || '';
      this.privacyDialogVisible = true;
    },

    closePrivacyDialog() {
      this.privacyDialogVisible = false;
      this.selectedPrivacy = this.originalPrivacy;
      this.currentEditingRow = null;
      this.privacyUpdating = false;
    },

    async confirmPrivacyChange() {
      if (this.selectedPrivacy === this.originalPrivacy) {
        this.closePrivacyDialog();
        return;
      }

      this.privacyUpdating = true;
      try {
        const res = await updateYoutubeVideo({
          youtubeCredentialId: this.currentEditingRow.youtubeCredentialId,
          videoId: this.currentEditingRow.videoId,
          privacy: this.selectedPrivacy,
          categoryId: this.currentEditingRow.categoryId,
        });

        if (res.code === 0) {
          this.currentEditingRow.status = this.selectedPrivacy;
          this.$message.success('更新成功');
          this.closePrivacyDialog();
        } else {
          this.privacyUpdating = false;
        }
      } catch (error) {
        console.log('更新视频公开范围失败:', error);
        this.privacyUpdating = false;
      }
    },

    confirmDelete(row) {
      this.currentDeleteRow = row;
      this.$confirm('确定要删除这个视频吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteVideoItem();
        })
        .catch(() => {});
    },

    async deleteVideoItem() {
      this.deleting = true;
      try {
        const res = await deleteVideo({
          videoId: this.currentDeleteRow.videoId,
          youtubeCredentialId: this.currentDeleteRow.youtubeCredentialId,
        });

        if (res.code === 0) {
          this.$message.success('删除成功');
          this.loadVideos();
        }
      } catch (error) {
        console.log('删除视频失败:', error);
      } finally {
        this.deleting = false;
        this.currentDeleteRow = null;
      }
    },

    copyLink(row) {
      if (row.youtubeVideoUrl) {
        navigator.clipboard
          .writeText(row.youtubeVideoUrl)
          .then(() => {
            this.$message.success('链接已复制到剪贴板');
          })
          .catch(() => {
            this.$message.error('复制失败');
          });
      } else {
        this.$message.warning('视频链接不存在');
      }
    },
  },
};
</script>

<style scoped>
.video-dialog {
  .search-form {
    display: flex;
    align-items: center;
  }

  .load-more {
    text-align: center;
    padding: 20px 0;
  }
}

::v-deep .video-dialog-wrapper {
  height: 80vh;
  margin-top: 10vh !important;
}

::v-deep .video-dialog-wrapper .el-dialog__body {
  height: calc(80vh - 30px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

::v-deep .el-table {
  flex: 1;
}

.load-more {
  flex-shrink: 0;
}

.edit-title {
  display: flex;
  align-items: center;
}

.title-display {
  display: flex;
  align-items: center;
  span {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.privacy-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.hover-cell {
  position: relative;

  .edit-icon {
    opacity: 0;
    cursor: pointer;
    color: #409eff;
    margin-left: 8px;
    transition: opacity 0.2s;
  }

  &:hover .edit-icon {
    opacity: 1;
  }
}
</style>
